import api from "./api";

export const callGetDashboardWinners = async (page, offset) => {
    try {
        return await api.get(`/winners/dashboard/all?page=${page}&offset=${offset}`);
    } catch (error) {
        console.log("Error callGetDashboardWinners");
        return error?.response || { status: 500 };
    }
};

export const callCreateDashboardWinner = async (data, photos) => {
    try {
        const formData = new FormData();

        // Agregar el objeto 'winner' como JSON serializado
        const winnerBlob = new Blob([JSON.stringify(data)], {
            type: "application/json",
        });
        formData.append("winner", winnerBlob);

        // Agregar las fotos si existen
        if (photos && photos.length > 0) {
            photos.forEach((file, index) => {
                formData.append("photos", file); // No uses photos[index], usa el mismo nombre para todos
            });
        }

        return await api.post(`/winners/dashboard/create`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch (error) {
        console.log("Error callCreateDashboardWinner");
        return error?.response || { status: 500 };
    }
};

export const callUpdateDashboardWinner = async (data, photos) => {
    try {
        const formData = new FormData();

        // Agregar el objeto 'winner' como JSON serializado
        const winnerBlob = new Blob([JSON.stringify(data)], {
            type: "application/json",
        });
        formData.append("winner", winnerBlob);

        // Agregar las fotos si existen
        if (photos && photos.length > 0) {
            photos.forEach((file, index) => {
                formData.append("photos", file);
            });
        }

        return await api.put(`/winners/dashboard/update/${data.winnerHistoryId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    } catch (error) {
        console.log("Error callUpdateDashboardWinner");
        return error?.response || { status: 500 };
    }
};

export const callGetWebWinners = async (page, offset) => {
    try {
        return await api.get(`/winners/web/all?page=${page}&offset=${offset}`);
    } catch (error) {
        console.log("Error callGetWebWinners");
        return error?.response || { status: 500 };
    }
};
